export const DefaultFontFamily = [
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  'Oxygen-Sans',
  'Ubuntu',
  'Cantarell',
  '"Fira Sans"',
  '"Droid Sans"',
  '"Helvetica Neue"',
  'Helvetica',
  '"ヒラギノ角ゴ Pro W3"',
  '"Hiragino Kaku Gothic Pro"',
  'メイリオ',
  'Meiryo',
  '"ＭＳ Ｐゴシック"',
  'Arial',
  'sans-serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
].join(',');

export const BoldFontFamily = [
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  'Oxygen-Sans',
  'Ubuntu',
  'Cantarell',
  '"Fira Sans"',
  '"Droid Sans"',
  '"Helvetica Neue Bold"',
  'Helvetica',
  '"ヒラギノ角ゴ Pro W3"',
  '"Hiragino Kaku Gothic Pro"',
  'メイリオ',
  'Meiryo',
  '"ＭＳ Ｐゴシック"',
  'Arial',
  'sans-serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
].join(',');
